import moment from "moment";
import _sortBy from "lodash/sortBy";

/**
 * The API returns a requirement's files in no particular order and every spec
 * save rewrites them, so their order flips between responses. Sorting by upload
 * date (id breaks ties) keeps each file on the same row, so the user doesn't
 * end up editing or approving the file that just moved into the row they
 * clicked.
 */
const sortSubmittalFiles = submittalFiles =>
  _sortBy(submittalFiles || [], [
    ({ createdAt }) => moment(createdAt).valueOf(),
    ({ id }) => Number(id),
  ]);

export default sortSubmittalFiles;
